import React from 'react';
import { reportError } from '../../services/errorReporter';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    reportError(error, { componentStack: errorInfo?.componentStack });
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div
        role="alert"
        style={{
          textAlign: 'center',
          padding: '50px 20px',
          maxWidth: '600px',
          margin: '0 auto',
        }}
      >
        <h2 style={{ color: 'var(--color-text)', marginBottom: '16px' }}>
          Something went wrong
        </h2>
        <p style={{ marginBottom: '24px', color: 'var(--color-text-muted)' }}>
          The page hit an unexpected error and couldn't render. Reload to try
          again. If it keeps happening, contact an administrator.
        </p>
        <button
          type="button"
          className="btn-primary"
          onClick={this.handleReload}
        >
          Reload page
        </button>
      </div>
    );
  }
}
